<template>
  <VModal
      :title="role.name ? 'ویرایش نقش ' + role.name : 'ایجاد نقش'"
      :show="show">

    <VAlert class="mt-4" type="danger" v-if="errors.length > 0">
      <div v-for="(error, index) in errors"
           :key="error" :class="{'font-bold' : index === 0}">
        {{ index !== 0 ? '- ' + error : error }}
      </div>
    </VAlert>

    <form @submit.prevent="submit" ref="form">
      <input type="hidden" name="_method" value="PUT" v-if="role.name">

      <div class="mt-5">
        <label>نام نقش</label>
        <VInput type="text" name="name" :value="role.name" placeholder="نام نقش" class="mt-4" required/>
      </div>

      <div class="flex justify-between mt-5">
        <div>
          <label>از اتاق</label>
          <VInput type="number" name="from_room_number" :value="role.from_room_number" class="mt-4" placeholder="از اتاق"/>
        </div>

        <div>
          <label>تا اتاق</label>
          <VInput type="number" name="to_room_number" :value="role.to_room_number" class="mt-4" placeholder="تا اتاق"/>
        </div>
      </div>

      <div class="mt-5">
        <label>نوع</label>
        <select name="type" class="bg-dark-form rounded-lg w-full mt-4 p-3 ">
          <option value="" disabled>انتخاب نوع</option>
          <option value="user" :selected="role.type === 'user'">میهمان</option>
          <option value="admin" :selected="role.type === 'admin'">ادمین</option>
          <option value="shop" :selected="role.type === 'shop'">فروشگاه</option>
          <option value="restaurant" :selected="role.type === 'restaurant'">رستوران</option>
          <option value="caffe" :selected="role.type === 'caffe'">کافی شاپ</option>
          <option value="housekeeping" :selected="role.type === 'housekeeping'">خانه داری</option>
          <option value="reception" :selected="role.type === 'reception'">پذیرش</option>
        </select>
      </div>

      <VButton type="submit" class="mt-10 w-full">ثبت</VButton>

      <VLoadingScreen :show="loading"/>
    </form>

  </VModal>
</template>

<script>
import VModal from "@/components/General/VModal";
import VInput from "@/components/General/VInput";
import VButton from "@/components/General/VButton";
import {createRole, updateRole} from "@/API/API";
import VAlert from "@/components/General/VAlert";
import VLoadingScreen from "@/components/General/VLoadingScreen";

export default {
  name: "ModalRole",
  components: {VLoadingScreen, VAlert, VButton, VInput, VModal},
  props: {
    show: Boolean,
    role: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      active: 1,
      loading: false,
      errors: [],
    }
  },
  methods: {
    submit() {
      this.loading = true
      this.errors = []

      let role = new FormData(this.$refs.form)

      if (this.role.name) {
        this.updateRole(role)
      } else {
        this.createRole(role)
      }
    },
    updateRole(role) {
      updateRole(this.role.id, role)
          .then(resp => {
            this.$emit('edited', resp.data)
          })
          .catch(err => {
            this.$helper.validationError(err, this.errors);
          })
          .finally(() => {
            this.loading = false
          })
    },
    createRole(role) {
      createRole(role)
          .then(resp => {
            this.$emit('created', resp.data)
          })
          .catch(err => {
            this.$helper.validationError(err, this.errors);
          })
          .finally(() => {
            this.loading = false
          })
    }
  }

}
</script>

<style scoped>

</style>